export default __webpack_public_path__ + "static/media/tequila.def9670d.png";